import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GOALS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_GOAL: ({ commit, dispatch }, goal) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals`, goal).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_GOAL: ({ commit, dispatch }, {goalId, goal}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/goals/${goalId}`, goal).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GOAL: ({ commit, dispatch }, goalId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/goals/${goalId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_GOALS: ({ commit, dispatch }, goalIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals/delete`, { goals_ids: goalIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SET_GOAL_STATE: ({ commit, dispatch }, {goalId, state}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals/${goalId}/set-state`, { state: state }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GOAL_STATS: ({ commit, dispatch }, {goalId, periodDays}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals/${goalId}/stats`, { period_days: periodDays }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  UPDATE_CUSTOM_GOAL_PROGRESS: ({ commit, dispatch }, {goalId, progress}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/goals/${goalId}/update-progress`, { progress: progress }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/goal/actions.js